// @ts-ignore
import { Box } from 'theme-ui'
import React, { FC, SVGProps } from 'react'

enum Direction {
  'up' = 'up',
  'down' = 'down',
  'left' = 'left',
  'right' = 'right',
}

type Props = SVGProps<SVGSVGElement> & {
  color?: string
  direction?: Direction | string
}

const rotate = (direction: Direction) => {
  switch (direction) {
    case 'down':
      return `rotate(90deg)`
    case 'left':
      return `rotate(180deg)`
    case 'up':
      return `rotate(-90deg)`
    case 'right':
    default:
      return 'none'
  }
}

const Chevron: FC<Props> = ({ color = 'currentColor', direction = Direction.right, ...rest }) => {
  return (
    <Box
      as="svg"
      width="49"
      height="81"
      viewBox="0 0 49 81"
      fill="none"
      sx={{
        // @ts-ignore
        transform: rotate(direction),
      }}
      {...rest}
    >
      <line
        y1="-1"
        x2="59.7332"
        y2="-1"
        transform="matrix(0.74341 0.668836 0.778945 -0.627092 2.10718 0)"
        stroke={color}
        strokeWidth="2"
      />
      <line
        y1="-1"
        x2="59.7332"
        y2="-1"
        transform="matrix(-0.74341 0.668836 -0.778945 -0.627092 46.5136 39.5961)"
        stroke={color}
        strokeWidth="2"
      />
    </Box>
  )
}

export default Chevron
